export default __webpack_public_path__ + "france-relance.247f535.png";